module.exports = __webpack_public_path__ + "assets/img/click.2e8312e2.png";